//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getFeedbackRecords, saveFeedbackRecord} from '../../../../api/workOrder';

export default {
  name: 'page-feedback-view',
  props: {
    workOrderId: {
      required: true,
      type: Number
    }
  },
  data() {
    return {
      saving: false,
      feedbackRecords: [],
      saveFeedbackRecording: false,
      showCreateFeedbackRecord: false,
      feedbackRecordInputDto: {},
      showFeedbackRecordModel: false
    };
  },
  computed: {
    workOrderInfo() {
      return this.$store.state.workOrder.workOrderInfo;
    }
  },
  methods: {
    onSaveFeedbackRecord() {
      //保存客户反馈
      const vm = this;
      vm.feedbackRecordInputDto.workOrderId = vm.workOrderId;
      vm.saveFeedbackRecording = true;
      saveFeedbackRecord(vm.feedbackRecordInputDto).then(res => {
        vm.showCreateFeedbackRecord = false;
        vm.showFeedbackRecordModel = false;
        vm.getFeedbackRecords();
        vm.$emit('onRefreshOperationLog')
      }).finally(() => {
        vm.saveFeedbackRecording = false;
      });
    },
    hasPermission(permission) {
      return abp.auth.isGranted(permission);
    },

    showCreateFeedbackRecordView() {
      if (this.workOrderInfo.status !== 1) {
        this.$Message.warning('工单状态需为“处理中”！');
        return;
      }
      this.feedbackRecordInputDto = {};
      this.showCreateFeedbackRecord = !this.showCreateFeedbackRecord;
    },
    getFeedbackRecords() {
      const vm = this;
      getFeedbackRecords(vm.workOrderId).then(res => {
        vm.feedbackRecords = [];
        vm.feedbackRecords.push(...res.data.result.items);
      }).finally(() => {

      });
    },

    show() {
      this.feedbackRecordInputDto = {};
      this.showFeedbackRecordModel = true;
    }
  },
  created() {
    // this.getFeedbackRecords();
  },
  watch: {
    // workOrderId(value, oldValue) {
    //     if (value > 0) {
    //         this.workOrderId = value;
    //         this.getFeedbackRecords();
    //     }
    // }
  }
};
